define([
    'react',
    'lodash',
    'font-awesome-webpack',
    './styles/moon-icon.less',
    './styles/symbols.less'
], function (React, _, FontAwesomeWebPack, MoonIconLess, DialogLess) {
    'use strict';
    return function () {
        return React.createElement('i', {
            'className': this.getClass(),
            'onClick': this.props.onClick
        });
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/icons/icon/icon.rt
 ** module id = 106
 ** module chunks = 0
 **/